import { render, staticRenderFns } from "./DarkSlots.vue?vue&type=template&id=fe51a538&scoped=true"
import script from "./DarkSlots.vue?vue&type=script&lang=js"
export * from "./DarkSlots.vue?vue&type=script&lang=js"
import style0 from "./DarkSlots.vue?vue&type=style&index=0&id=fe51a538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe51a538",
  null
  
)

export default component.exports